import { defineExtension } from "lexical"

export default class LexxyExtension {
  #editorElement

  constructor(editorElement) {
    this.#editorElement = editorElement
  }

  get editorElement() {
    return this.#editorElement
  }

  get editorConfig() {
    return this.#editorElement.config
  }

  // optional: defaults to true
  get enabled() {
    return true
  }

  get lexicalExtension() {
    return null
  }

  get allowedElements() {
    return []
  }

  get allowedStyles() {
    return []
  }

  defineExtension(...args) {
    return defineExtension(...args)
  }

  initializeToolbar(_lexxyToolbar) {
  }

  setEditorValidity(flags, message) {
    this.editorElement.setElementValidity(this, flags, message)
  }

  dispose() {
  }
}
